import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import mixpanelEvents from '@Mixpanel';
import { setTopicFlags } from '@Actions/filterActions';
import { MultiSelectDropdown } from '@Components/UI/Dropdowns';
import { FilterDiv, InBodyTitle } from '../ScoreCardFilters.style';

const TopicsFilter = () => {
    const dispatch = useDispatch();

    const topicFlagsInput = useSelector(state => state.scoreCardFilters.topicFlagsInput);

    return (
        <FilterDiv>
            <InBodyTitle>Filter topics</InBodyTitle>
            <MultiSelectDropdown
                name="topics"
                searchBox
                options={topicFlagsInput}
                setOptions={input => {
                    dispatch(setTopicFlags(input));
                    mixpanelEvents.scorecardFiltersApplied();
                }}
            />
        </FilterDiv>
    );
};

export default TopicsFilter;
